import React, { ReactNode } from "react";
import styled from "styled-components";
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import PinBackground from '../../../icons/map-pin-background';
import PinLogo from '../../../icons/map-pin-logo';
import { BRANCH_TYPE } from "../../../utilities/enums";
import { FeatureFlags, getFeatureFlag } from "../../../utilities/featureFlags";

export interface IMarkerProps {
    latitude: string;
    longitude: string;
    id: string;
    selectedId: string;
    type: number;
    markerContent: ReactNode;
    onClick: (id: string) => void;
    className?: string;
}

export default styled(({ latitude, longitude, id, onClick, selectedId, type, className = '', markerContent }: IMarkerProps) => {
    const enableBranchesWaitTimes = getFeatureFlag(FeatureFlags.ENABLE_BRANCHES_WAIT_TIMES)

    function handleClick() {
        if (typeof onClick === "function") {
            onClick(id);
        }
    }

    function renderPinContent () {
        if (type === BRANCH_TYPE.MACU_ATM || type === BRANCH_TYPE.PARTNER_ATM) {
            return (
                <div className="atm text-white text-center">ATM</div>
            )
        } else if (enableBranchesWaitTimes && markerContent) {
            return (
                <div className="marker-content text-white text-center d-flex flex-column">{markerContent}</div>   
            )
        } else {
            return null;
        }
    }

    return (
        <AdvancedMarker zIndex={selectedId == id ? 1 : 0} className={className} onClick={handleClick} position={{ lat: parseFloat(latitude), lng: parseFloat(longitude) }} >
            <div className="marker-container">
                <PinLogo className="marker-logo" />
                <PinBackground active={selectedId == id} />
                { renderPinContent() }
            </div>
        </AdvancedMarker>
    );
})`
    .marker-container {
        height: 5.5rem;
        width: 4rem;
        position: relative;

        .marker-logo {
            height: 1.6rem;
            width: 3.2rem;
            position: absolute;
            top: .4rem;
            left: .4rem;
            fill: white;
            z-index: 1;
        }
        .atm {
            font-size: 1rem;
            font-family: 'National2 Narrow';
            width: 100%;
            position: absolute;
            bottom: 2rem;
        }

        .marker-content {
            font-size: 1.333rem;
            font-family: 'National2 Narrow';
            width: 100%;
            position: absolute;
            top: 2rem;

            span {
                line-height: 1;
            }
            .small {
                font-size: 0.5rem;
                line-height: 1;
                text-transform: uppercase;
            }
        }
    }
`;